import React from 'react';
import Box from '@mui/material/Box';
import ClearRoundedIcon from '@mui/icons-material/ClearRounded';
import { bool, func, shape, string } from 'prop-types';
import Filters from './Filters';

const MobileFilters = props => {
  const {
    definedValues,
    filters,
    getParams,
    initialState,
    isFiltersOpen,
    persistFilters,
    setFilters,
    setIsFiltersOpen,
    setPageNumber,
    tab,
    triggerAuto,
    triggerManual,
  } = props;

  return (
    <>
      <Box
        sx={{
          backgroundColor: 'surface.white',
          boxShadow: 1,
          display: 'flex',
          justifyContent: 'flex-end',
          pr: 1,
          py: 2,
          top: 0,
          zIndex: 2,
        }}
      >
        <ClearRoundedIcon onClick={() => setIsFiltersOpen(false)} sx={{ color: 'graphic.icons' }} />
      </Box>
      <Filters
        definedValues={definedValues}
        filters={filters}
        getParams={getParams}
        initialState={initialState}
        isFiltersOpen={isFiltersOpen}
        persistFilters={persistFilters}
        setFilters={setFilters}
        setIsFiltersOpen={setIsFiltersOpen}
        setPageNumber={setPageNumber}
        tab={tab}
        triggerAuto={triggerAuto}
        triggerManual={triggerManual}
      />
    </>
  );
};

MobileFilters.propTypes = {
  definedValues: shape({}).isRequired,
  filters: shape({}).isRequired,
  getParams: shape({}).isRequired,
  initialState: shape({}).isRequired,
  isFiltersOpen: bool.isRequired,
  persistFilters: func.isRequired,
  setFilters: func.isRequired,
  setIsFiltersOpen: func.isRequired,
  setPageNumber: func.isRequired,
  tab: string.isRequired,
  triggerAuto: func.isRequired,
  triggerManual: func.isRequired,
};

export default MobileFilters;
